// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"624":"3daf7928ef1cb97d","728":"cb1f35c4449e4f35","946":"cb1f35c4449e4f35"}[chunkId] + ".css";
};